import { map, pluck, filter } from 'rxjs/operators'
import { ofType, ActionsObservable } from 'redux-observable'
import { ReduxAction } from '../../../reducers/reducerType'
import { TrackType } from '../../../actions/tracks/trackTypes'
import { createLocalAudioTrack } from '../../../actions/tracks/trackActions'
import { AudioSource } from '../../../reducers/tracks/tracksReducerDefaultState'

/** Listens out for a change of audio source to microphone and triggers a local audio track creation */
export default (actions$: ActionsObservable<ReduxAction>) => actions$.pipe(
  ofType(TrackType.SET_AUDIO_SOURCE),
  pluck<ReduxAction, AudioSource>('payload'),
  filter(audioSource => audioSource === 'microphone'),
  map(() => createLocalAudioTrack())
)
